import React from 'react'
import { BreadcrumbLink } from 'Components/Shared/BreadCrumb/BreadCrumb'
import SubnavBar from 'Components/Shared/SubnavBar'

type Props = {
  name?: string
  onClose?: () => void
}

const Breadcrumbs: React.ComponentType<Props> = props => {
  const { name } = props
  const breadcrumbs: BreadcrumbLink[] = [
    {
      url: '/unit/dashboard',
      title: 'Home',
      icon: '/home.png',
      active: true,
      showTitle: false,
    },
    {
      url: '/unit/dashboard',
      title: 'บอร์ด',
      active: true,
      showTitle: true,
    },
    {
      url: `/unit/document/`,
      title: 'ตรวจเอกสาร',
      active: false,
      showTitle: true,
    },
  ]

  return <SubnavBar breadcrumbs={breadcrumbs} hideSearch={true} />
}

export default Breadcrumbs
